import React from 'react'
import '../../assets/css/loader.css'

const Loading = () => {
    return (
        <div className="loadingWrapper">
            <img src="//vivense.com/img/kalp.gif" alt="Loding" />
        </div>
    )
}

export default Loading
